import styled from 'styled-components'
import Rating from '../Rating/Rating'

const lightOrDark = (color) => {
  // Variables for red, green, blue values
  let r, g, b, hsp

  // Check the format of the color, HEX or RGB?
  if (color.match(/^rgb/)) {
    // If RGB --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/)

    r = color[1]
    g = color[2]
    b = color[3]
  } else {
    // If hex --> Convert it to RGB: http://gist.github.com/983661
    color = +('0x' + color.slice(1).replace(color.length < 5 && /./g, '$&$&'))

    r = color >> 16
    g = (color >> 8) & 255
    b = color & 255
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Using the HSP value, determine whether the color is light or dark (> 127.5)
  if (hsp > 127.5) {
    return 'light'
  } else {
    return 'dark'
  }
}

export const StyledProgressContainer = styled.div`
  position: relative;
  margin-bottom: 30px;
`

export const StyledRating = styled(Rating)`
  display: inline-block;

  svg {
    position: relative;
    top: -3px;
  }
`

export const StyledPassingMarker = styled.div.attrs((props: { percentage: number }) => ({
  percentage: props.percentage || 0
}))`
  position: absolute;
  left: ${(props) => props.percentage}%;
  border-left: 1px solid #9a9a9a;
  height: 40px;
  z-index: 1;
  margin: 10px 0;
  color: #9a9a9a;

  > div {
    position: relative;
    bottom: -40px;
    left: -50%;
  }
`

export const StyledProgressWraper = styled.div`
  overflow: hidden;
  padding: 10px 0 5px;
  position: relative;

  .progress-bar {
    background-color: #${(props) => props['primary-color']} !important;

    > div {
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #${(props) => props['secondary-color']};
      color: ${(props) => (lightOrDark(props['secondary-color']) === 'light' ? '#000' : '#fff')} !important;
    }
  }
`

export const StyledProgress = styled.div`
  overflow: visible !important;
  margin-top: 5px;
  height: 30px !important;
  background: #9a9a9a;
  > div {
    height: 40px;
    margin-top: -5px;
  }
  .bg-danger {
    background-color: $nexgen-red !important;
  }
`

export const StyledProgressDescription = styled.div.attrs({
  className: 'text-center'
})`
  color: #9a9a9a;
  margin-top: 30px;
`

export const StyledCurrentScore = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  padding: 0 15px;
`

export const StyledTextOverlay = styled.div`
  position: absolute;
  top: 17px;
  right: 15px;
  color: #fff;
`
